<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>In the evolution of the Earth and the human species this time that we live in is undoubtedly the best time to be born into.</p>
<p>The METAVERSE is continually evolving. With the degradation of the planet, nature as we know it will cease to exist and will be replaced by technology in the form of ‘bubble precincts’; enclosed areas with artificially controlled temperatures, humidity and light. Our daily lives will be highly regulated, family life as we know it will cease to exist and we will have very few personal possessions.</p>
<p>With advances in technology many people will visit ‘this time’ in virtual reality to experience the wonder, the beauty, and the challenges it has to offer. The huge numbers visiting over millions of years far outweigh the relatively small number of people who once passed through in natural evolution. It follows therefore that anyone living in this time is most likely to be in virtual reality.</p>
<p>A person contemplating this hypothesis in the UNFOLDING METAVERSE must ask the question, “AM I REAL OR AM I VIRTUAL?”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1f3d505c